export const SITE_NAME = "株式会社ナンバ";
export const SITE_LOGO =
  "https://public.readdy.ai/ai/img_res/3ed906d4-1f36-4b5e-9490-d005e87a1182.png";

export type StructuredData = Record<string, unknown>;

export interface PageMeta {
  title: string;
  description: string;
}

const getOrigin = (): string =>
  typeof window !== "undefined" ? window.location.origin : "";

export const seoMeta = {
  home: {
    title: "人材みえる化ソリューション｜VR・ARで組織を可視化｜株式会社ナンバ",
    description:
      "株式会社ナンバの人材みえる化ソリューション。VR・ARとデータ分析の力で、人材のスキル・適性・配置をひとつの画面に見える化し、組織の意思決定をデータで支えます。かんたん操作・明朗な料金・豊富な導入実績で、500社以上に選ばれています。",
  },
  company: {
    title: "会社概要｜株式会社ナンバ｜人材みえる化ソリューション",
    description:
      "株式会社ナンバの会社概要。人材の本質を科学的に見える化する独自システム「A-SYSTEM」を中心に、適性検査・営業支援・事業支援を通じて組織の成長を支えています。所在地・電話番号・受付時間などの基本情報もご案内します。",
  },
  privacy: {
    title: "プライバシーポリシー｜株式会社ナンバ",
    description:
      "株式会社ナンバのプライバシーポリシーです。個人情報の取得・利用目的、第三者提供の有無、安全管理措置、開示・訂正・削除のご請求方法など、お客様の個人情報の取り扱いについて定めています。安心してサービスをご利用いただくための方針を掲載しています。",
  },
  terms: {
    title: "利用規約｜株式会社ナンバ",
    description:
      "株式会社ナンバが提供する人材みえる化ソリューションの利用規約です。サービスのご利用条件、禁止事項、料金・お支払い、免責事項、著作権の取り扱いなどについて定めています。ご利用前に必ずご確認ください。",
  },
  legalNotice: {
    title: "特定商取引法に基づく表記｜株式会社ナンバ",
    description:
      "株式会社ナンバの特定商取引法に基づく表記です。販売事業者、運営統括責任者、所在地、連絡先、販売価格、お支払い方法、引渡し時期、返品・キャンセルに関する条件などを掲載しています。",
  },
} satisfies Record<string, PageMeta>;

export function organizationCoreJsonLd(): StructuredData {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE_NAME,
    alternateName: "NAMBA Inc.",
    url: `${getOrigin()}/`,
    logo: SITE_LOGO,
  };
}

export function organizationFullJsonLd(): StructuredData {
  return {
    ...organizationCoreJsonLd(),
    foundingDate: "2026-08",
    founder: { "@type": "Person", name: "難波 伸敏" },
    address: {
      "@type": "PostalAddress",
      postalCode: "115-0056",
      addressRegion: "東京都",
      addressLocality: "北区",
      streetAddress: "西が丘2-1-11",
      addressCountry: "JP",
    },
    telephone: "+81-3-6454-3314",
    email: "info@namba.ne.jp",
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+81-3-6454-3314",
      contactType: "customer service",
      areaServed: "JP",
      availableLanguage: "Japanese",
    },
    openingHoursSpecification: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "09:30",
      closes: "18:30",
    },
  };
}

export function websiteJsonLd(): StructuredData {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE_NAME,
    url: `${getOrigin()}/`,
    inLanguage: "ja-JP",
  };
}